import * as types from "../constants/auth_constants";

const initialState = {
  userData: null,
  accessToken: null,
  signInError: null,
  signUpError: null,
  updateError: null,
};

const authReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.SET_ACCESS_TOKEN:
      return { ...state, accessToken: payload ? payload : null };

    case types.SET_USER_DATA:
      return { ...state, userData: payload ? payload : null };

    case types.SIGNIN_SUCCESS:
      return {
        ...state,
        userData: payload ? payload.user : null,
        accessToken: payload ? payload.token : null,
      };

    case types.SIGNIN_FAIL:
      return { ...state, signInError: payload ? payload : null };

    case types.LOGOUT:
      return { ...state, userData: null, accessToken: null };

    default:
      return state;
  }
};

export default authReducer;
